if (!customElements.get('yns-product-carousel')) {
  customElements.define(
    'yns-product-carousel',
    class YnsProductCarousel extends HTMLElement {
      constructor() {
        super();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      connectedCallback() {
        const cards = Array.from(this.querySelectorAll('.yns-product-card-wrap'));

        this.querySelectorAll('[data-quick-add]').forEach((btn) => {
          btn.addEventListener('click', (e) => this.handleQuickAdd(e, btn));
        });

        if (this.reducedMotion) {
          cards.forEach((card) => card.classList.add('is-visible'));
          return;
        }

        this.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.io.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
        );

        cards.forEach((card) => this.io.observe(card));
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      handleQuickAdd(event, btn) {
        event.preventDefault();
        event.stopPropagation();
        const variantId = btn.dataset.variantId;
        if (!variantId || btn.dataset.state === 'loading') return;
        btn.dataset.state = 'loading';

        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');

        const sections = ['cart-icon-bubble'];
        if (cartDrawer) sections.push('cart-drawer');
        if (cartNotification) sections.push('cart-notification-product', 'cart-notification-button');

        fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((res) => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
          })
          .then((data) => {
            btn.dataset.state = 'added';

            this.updateCartBubble(data);

            if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
              cartDrawer.renderContents(data);
            } else if (cartNotification && typeof cartNotification.renderContents === 'function' && data.sections) {
              cartNotification.renderContents(data);
            } else {
              this.showAddedToast();
            }

            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));

            if (
              typeof publish === 'function' &&
              typeof PUB_SUB_EVENTS !== 'undefined' &&
              PUB_SUB_EVENTS.cartUpdate
            ) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'yns-product-grid',
                productVariantId: String(variantId),
                cartData: data,
              });
            }

            setTimeout(() => {
              if (btn.dataset.state === 'added') btn.removeAttribute('data-state');
            }, 1600);
          })
          .catch((err) => {
            console.error('Quick add failed:', err);
            btn.removeAttribute('data-state');
          });
      }

      updateCartBubble(data) {
        const html = data && data.sections && data.sections['cart-icon-bubble'];
        const bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;
        try {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.querySelector('.shopify-section');
          bubble.innerHTML = section ? section.innerHTML : doc.body.innerHTML;
        } catch (e) {
          /* no-op */
        }
      }

      ensureToastStyles() {
        if (document.getElementById('yns-cart-toast-styles')) return;
        const style = document.createElement('style');
        style.id = 'yns-cart-toast-styles';
        style.textContent = [
          '#yns-cart-toast{position:fixed;left:50%;bottom:24px;transform:translate(-50%,20px);z-index:1000;display:flex;align-items:center;gap:16px;background:#2c2c2c;color:#fff;padding:13px 18px;border-radius:12px;box-shadow:0 10px 34px rgba(0,0,0,.22);font-family:"Inter",Helvetica,Arial,sans-serif;font-size:14px;line-height:1;opacity:0;visibility:hidden;transition:opacity .25s ease,transform .25s ease;max-width:calc(100% - 32px);}',
          '#yns-cart-toast.is-visible{opacity:1;visibility:visible;transform:translate(-50%,0);}',
          '#yns-cart-toast .yns-toast-msg{display:inline-flex;align-items:center;font-weight:500;}',
          '#yns-cart-toast .yns-toast-link{color:#fff;text-decoration:underline;font-weight:600;white-space:nowrap;}',
          '@media (prefers-reduced-motion:reduce){#yns-cart-toast{transition:none;}}',
        ].join('');
        document.head.appendChild(style);
      }

      showAddedToast() {
        this.ensureToastStyles();
        let toast = document.getElementById('yns-cart-toast');
        if (!toast) {
          toast = document.createElement('div');
          toast.id = 'yns-cart-toast';
          toast.setAttribute('role', 'status');
          toast.setAttribute('aria-live', 'polite');
          const cartUrl = `${window.Shopify?.routes?.root || '/'}cart`;
          toast.innerHTML =
            '<span class="yns-toast-msg"><svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true" style="vertical-align:-3px;margin-right:8px"><path d="M3 8.5l3.2 3.2L13 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Added to cart</span>' +
            '<a class="yns-toast-link" href="' + cartUrl + '">View cart</a>';
          document.body.appendChild(toast);
        }
        setTimeout(() => toast.classList.add('is-visible'), 20);
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(() => {
          toast.classList.remove('is-visible');
        }, 4200);
      }
    }
  );
}
